"use client";

import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi } from "@/components/ui/carousel";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const slides = [{
  title: "Annual Retreat",
  description: "Co roku wychodzimy poza biuro, żeby wrócić do niego z nową perspektywą.",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1614558/img/culture_retreat_new.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1614558/img/culture_retreat_new.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1614558/img/culture_retreat_new.png-wvc-sizes",
  alt: "Pracownicy poza biurem"
}, {
  title: "Nasza Przestrzeń",
  description: "Nowe biuro BH Marketing - przestrzeń zaprojektowana z taką samą uwagą do szczegółu, jakiej oczekujemy od każdej naszej realizacji\n\n\n\n",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1614558/img/b299ad1f-84b9-4c0e-b332-d506b678baee_rw_1920.webp",
  srcset: "https://bhmarketing.pl/wp-content/uploads/2026/04/Projekt-bez-nazwy-2026-04-03T013908.442.png?v=f50hu8u12ue-wvc-srcset",
  sizes: "https://bhmarketing.pl/wp-content/uploads/2026/04/Projekt-bez-nazwy-2026-04-03T013908.442.png?v=d5725kxdtr6-wvc-sizes",
  alt: "Biuro BH Marketing ul. Podwale 19/5 Wrocław"
}, {
  title: "Nasz Wkład",
  description: "Wspieramy KS Szpada Wrocław — jeden z najlepszych polskich klubów szermierczych. Precyzja w sporcie i precyzja w biznesie mają ze sobą więcej wspólnego, niż się wydaje.",
  src: "https://bhmarketing.pl/wp-content/uploads/2026/05/IMG_4626-1-scaled.jpg?v=9liq2pal4oo",
  srcset: "https://bhmarketing.pl/wp-content/uploads/2026/05/IMG_4626-1-scaled.jpg?v=kwe6c0xlhzf",
  sizes: "https://bhmarketing.pl/wp-content/uploads/2026/05/IMG_4626-1-scaled.jpg?v=216nzs43h9e",
  alt: "Sponsorujemy KS Szpada Wrocław - wiodący polski klub szermierczy"
}];
export default function AtmosphereCultureCarousel() {
  const [api, setApi] = React.useState<CarouselApi>();
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  React.useEffect(() => {
    if (!api) return;
    const interval = setInterval(() => {
      api.scrollNext();
    }, 6000);
    return () => clearInterval(interval);
  }, [api]);
  return <section id="atmosphere-culture-carousel" className="bg-background py-12 md:py-16 overflow-hidden">
      <div className="container mx-auto px-6 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-8 md:mb-12">
          <div className="max-w-2xl animate-in fade-in slide-in-from-bottom-4 duration-700">
            <span className="inline-block text-primary font-mono text-sm font-bold tracking-widest uppercase mb-4">Nasze Środowisko</span>
            <h2 className="text-4xl md:text-6xl font-bold font-sans text-foreground tracking-tighter mb-6">Środowisko</h2>
            <p className="text-lg md:text-xl text-muted-foreground font-sans leading-relaxed">Środowisko, w którym pracujemy, kształtuje sposób, w jaki myślimy o klientach. Dlatego dbamy o nie tak samo uważnie, jak o wyniki kampanii.</p>
          </div>
        </div>

        <Carousel ref={ref} setApi={setApi} opts={{
        align: "start",
        loop: true
      }} className={`w-full transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <CarouselContent className="-ml-6 md:-ml-8">
            {slides.map((slide, i) => <CarouselItem key={i} data-index={i} className="pl-6 md:pl-8 basis-[85%] sm:basis-[60%] lg:basis-[40%]">
                <div className="group relative h-full overflow-hidden rounded-3xl border border-border bg-card shadow-sm transition-all duration-500 hover:shadow-xl hover:-translate-y-1">
                  <AspectRatio ratio={4 / 5} className="h-full">
                    <img src={slide.src} data-wvc-srcset={slide.srcset} data-wvc-sizes={slide.sizes} alt={slide.alt} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" loading="lazy" decoding="async" />
                    <div className="absolute inset-0 bg-gradient-to-t from-secondary/95 via-secondary/40 to-transparent opacity-80 transition-opacity duration-500 group-hover:opacity-90" />
                    
                    <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                      <h3 className="text-2xl md:text-3xl font-bold font-sans mb-4 tracking-tight">
                        {slide.title}
                      </h3>
                      <p className="text-sm md:text-base text-white/80 font-sans line-clamp-3 leading-relaxed">
                        {slide.description}
                      </p>
                    </div>
                  </AspectRatio>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          
          <div className="flex items-center justify-center gap-6 mt-10">
            {}
            <div className="hidden md:flex gap-4 animate-in fade-in slide-in-from-bottom-4 duration-700 delay-200">
              <div className="relative size-12">
                <CarouselPrevious className="static translate-y-0 left-0 size-12 rounded-lg border-2 border-primary text-primary hover:bg-primary hover:text-white transition-all shadow-md" />
              </div>
              <div className="relative size-12">
                <CarouselNext className="static translate-y-0 right-0 size-12 rounded-lg border-2 border-primary text-primary hover:bg-primary hover:text-white transition-all shadow-md" />
              </div>
            </div>

            {}
            <div className="flex md:hidden justify-center gap-6">
              <div className="relative size-12">
                <CarouselPrevious className="static translate-y-0 left-0 size-12 rounded-lg border-2 border-primary text-primary hover:bg-primary hover:text-white transition-all shadow-md" />
              </div>
              <div className="relative size-12">
                <CarouselNext className="static translate-y-0 right-0 size-12 rounded-lg border-2 border-primary text-primary hover:bg-primary hover:text-white transition-all shadow-md" />
              </div>
            </div>
          </div>
        </Carousel>

        <div className="mt-12 text-center animate-in fade-in slide-in-from-bottom-4 duration-700 delay-300">
          <h3 className="text-3xl md:text-4xl font-bold font-sans text-foreground tracking-tight mb-8">Gotowy dołączyć do zespołu, który myśli inaczej?</h3>
          <Link to="/ContactPage">
            <Button size="lg" className="rounded-lg px-8 py-6 text-lg font-semibold animate-in fade-in slide-in-from-bottom-4 duration-700 delay-500 hover:scale-105 transition-transform">Daj nam znać!</Button>
          </Link>
        </div>
      </div>
    </section>;
}